export class SiteDTO {
  public id: number = 0;
  public name: string = "";
  public technicalDomain: string = "gamfi.io";
}

export class Site {
  private _id: number;
  private _name: string;
  private _technicalDomain: string;

  constructor(site: SiteDTO) {
    this._id = site.id;
    this._name = site.name;
    this._technicalDomain = site.technicalDomain;
  }

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get technicalDomain() {
    return this._technicalDomain;
  }
}
